$(document).ready(function () {
    $('.read-more').click(function () {
      $('#containerDes').toggleClass('expanded');
      $('#readmore').toggleClass('hide');
      $('#readLess').toggleClass('show');
    });
    $(function () {
      var curHeight = $('#containerDes').height();
      if ((curHeight) => 120) {
        document.getElementById('heightCheck').style.display = 'block';
        console.log(curHeight);
      }
      if (curHeight < 120) {
        document.getElementById('heightCheck').style.display = 'none';
        document.getElementById('containerDes').classList.add('no-after');
      }
    });
  });
  